import KeenSlider from "keen-slider";
import event from "../lib/mixins/event";

class ImageGallery {
	constructor(dom) {
		this.NAME = "ImageGallery";
		this.dom = dom;
		this.slider = null;
	}

	init() {
		const sliderDom = this.dom.querySelector(".image-gallery__slider");
		const prevNav = this.dom.querySelector("[data-nav-prev]");
		const nextNav = this.dom.querySelector("[data-nav-next]");

		if (!sliderDom) return;

		const updateActive = (s) => {
			s.slides.forEach((slide, i) => {
				slide.classList.toggle("active", i === s.track.details.rel);
			});
		};

		this.slider = new KeenSlider(sliderDom, {
			loop: true,
			slides: { perView: 1.1, spacing: 0, origin: "center" },
			breakpoints: {
				"(min-width: 1024px)": {
					slides: { perView: 1.3, spacing: 0, origin: "center" },
				},
			},
			created: updateActive,
			slideChanged: updateActive,
		});

		if (prevNav) prevNav.addEventListener("click", () => this.slider.prev());
		if (nextNav) nextNav.addEventListener("click", () => this.slider.next());
	}

	destroy() {
		if (this.slider) {
			this.slider.destroy();
			this.slider = null;
		}
	}
}

Object.assign(ImageGallery.prototype, event);
export default ImageGallery;
